<template>
	<div class="body">
		<Header></Header>
		<div class="block">
			<div class="banner_about"></div>
			<div class="menu_block">
				<div class="content fsb">
					<dl class="menu">
						<dd>
							<router-link to="/about" active-class="select">公司介绍</router-link>
						</dd>
<!--						<dd>-->
<!--							<router-link to="/about2" active-class="select">企业文化</router-link>-->
<!--						</dd>-->
<!--						<dd>-->
<!--							<router-link to="/about2" active-class="select">专利认证</router-link>-->
<!--						</dd>-->
					</dl>
					<div class="location">
						当前位置：
						<a href="/">首页</a>
						<i class="icon el-icon-arrow-right"></i>
						<a href="">关于我们</a>
					</div>
				</div>
			</div>

			<div class="bg">
				<div class="about_block">
					<div class="img"></div>
					<div class="content">
						<div class="r">
							<div class="title">
								<span>公司介绍</span>
							</div>
							<div class="text">
								<p class="mt20">
                                    山东中喆德元智能装备有限公司总部坐落于泰安市，在潍坊、德州、沈阳均有分公司。主要生产基地在沈阳，设有研发、试验、国家级检测平台。主要从事
									<strong>自励三相异步电动机、本体激励电动机</strong>
                                    的研发、生产，成立了高效节能电动机工程技术研究中心、节能电机市场中心，该项目已入选山东省新旧动能转换重大项目库优选项目。
								</p>
								<h2 class="mt20">项目研发技术团队</h2>
								<p>
                                    电机及自动化专家15人、博士10人，硕士研究生20余人 。
                                    拥有本体激励电机全系列一级能效设计方案。与清华大学、沈阳工业大学等专业院校联合设计，可生产不同负载类型的电机系统节能产品，打造服务于现代工业的电机系统节能平台。
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="content">
				<div class="title_01 mt70">企业文化</div>
				<ul class="culture_list">
					<li class="i1">
						<span>使命</span>
						<p>
							智慧驱动智造，汇集行业精英，创新行业技术，用”智、汇、创“改造传统工艺及设备，为企业节能减碳，致力于把绿色、节能、高效的动力应用到全世界，早日实现全球碳中和。
						</p>
					</li>
					<li class="i2">
						<span>愿景</span>
						<p>创中国之精英，出世界之精品，做节能之首。</p>
					</li>
					<li class="i3">
						<span>价值观</span>
						<p>
							互学互助互爱，敢于突破自我，团结共创奇迹。服务积极热情，方案精准独特，为用户创造价值最大化。
						</p>
					</li>
				</ul>
			</div>

			<div class="content">
				<div class="title_01 mt70">专利认证</div>
				<div class="patent_block">
					<el-tabs v-model="activeName" >
						<el-tab-pane label="专利证书" name="1">
							<ul class="patent_list">
								<li><img src="../images/fmzl/1.jpg" alt=""></li>
								<li><img src="../images/fmzl/2.jpg" alt=""></li>
								<li><img src="../images/fmzl/3.jpg" alt=""></li>
								<li><img src="../images/fmzl/4.jpg" alt=""></li>
								<li><img src="../images/fmzl/5.jpg" alt=""></li>
								<li><img src="../images/fmzl/6.jpg" alt=""></li>
								<li><img src="../images/fmzl/7.jpg" alt=""></li>
								<li><img src="../images/fmzl/8.jpg" alt=""></li>
								<li><img src="../images/fmzl/9.jpg" alt=""></li>
								<li><img src="../images/fmzl/10.jpg" alt=""></li>
							</ul>
						</el-tab-pane>
						<el-tab-pane label="一级能效证书" name="2">
                            <ul class="patent_list">
                                <li><img src="../images/nxrz/1.jpg" alt=""></li>
                                <li><img src="../images/nxrz/2.jpg" alt=""></li>
                                <li><img src="../images/nxrz/3.jpg" alt=""></li>
                                <li><img src="../images/nxrz/4.jpg" alt=""></li>
                                <li><img src="../images/nxrz/5.jpg" alt=""></li>
                            </ul>
                        </el-tab-pane>
					</el-tabs>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
import Header from '../components/hearder.vue'
import Footer from '../components/footer.vue'

export default {
	data() {
		return {
			activeName: '1'
		}
	},
	components: {
		Header,
		Footer
	},

	methods: {
		
	}
}
</script>

<style lang="less" scoped>

.about_block {
	width: 100%;
	padding-left: calc(50% + 50px);
	display: flex;
	position: relative;

	.r {
		width: 690px;
		height: 525px;
		flex-shrink: 0;

		.title {
			position: relative;
			margin-top: 20px;
			span {
				font-size: 38px;
			}
		}
		.text {
			color: #000;
			font-size: 20px;
			line-height: 40px;

			strong {
				color: #1265a4;
			}
			h2 {
				font-size: 20px;
				font-weight: bold;
			}
		}
	}
	.img {
		width: 50%;
		height: 525px;
		background: url('../images/img_01.png') left no-repeat;
		position: absolute;
		top: 0;
		left: 0;
	}
}

.culture_list {
	width: 100%;
	margin-top: 45px;

	li {
		color: #fff;
		padding-left: 80px;
		display: inline-block;

		&.i1 {
			width: 680px;
			height: 500px;
			padding-top: 155px;
			padding-right: 120px;
			margin-right: 20px;
			background: url('../images/img_02.png') no-repeat;
			float: left;

			p {
				margin-top: 100px;
			}
		}
		&.i2 {
			width: 680px;
			height: 240px;
			padding-top: 50px;
			padding-right: 120px;
			background: url('../images/img_03.png') no-repeat;

			p {
				margin-top: 60px;
			}
		}
		&.i3 {
			width: 680px;
			height: 240px;
			padding-top: 50px;
			padding-right: 120px;
			margin-top: 20px;
			background: url('../images/img_04.png') no-repeat;

			p {
				margin-top: 60px;
			}
		}
		span {
			font-size: 30px;
			padding-bottom: 30px;
			position: relative;
			&::after {
				content: '';
				width: 45px;
				height: 6px;
				background: #fff;
				position: absolute;
				left: 0;
				bottom: 0;
			}
		}
		p {
			font-size: 16px;
			line-height: 32px;
		}
	}
}

.patent_block {
	width: 100%;
	margin-top: 30px;
	display: flex;
	justify-content: center;

	.patent_list{
		width: 100%;
		height: 430px;
		max-width: 1380px;
		display: flex;
		overflow-x: auto;
		
		li{
			width: 305px;
			height: 410px;
			background: #fff;
			border: 10px solid #fff;
			margin-right: 50px;
			flex-shrink: 0;
			
		}

        img{
            width: 285px;
            height: 410px;

        }
	}
}
/deep/.el-tabs__header{
	margin-bottom: 40px;
	display: flex;
	justify-content: center;
}
/deep/.el-tabs__active-bar,
/deep/.el-tabs__nav-wrap::after{
	display: none;
}
/deep/.el-tabs__item{
	color: #333;
	text-align: center;
	width: 150px;
	height: 44px;
	line-height: 44px;
	background: #ececec;
	padding: 0;
	border-radius: 8px;
	margin: 0 20px;
}
/deep/.is-active{
	color: #fff;
	background: #1265a4;
}
</style>
